import { FieldType } from "@entaconsulting/form";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  AccordionDetails,
  AccordionProps,
  AccordionSummary,
  Box,
  Chip,
  Accordion as MuiAccordion,
  Stack,
  Tooltip,
  Typography,
  styled,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import { FIELD_TYPE_OPTIONS } from "developer/edit/hooks/useInsertionMenuOptions";
import React, { PropsWithChildren } from "react";

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:before": {
    display: "none",
  },
  "& .MuiAccordionSummary-content": {
    width: "90%",
    alignItems: "center",
    gap: 8,
  },
}));

type EntaAccordionProps = PropsWithChildren<
  AccordionProps & {
    type?: FieldType;
  }
>;

const EntaAccordion: React.FC<EntaAccordionProps> = (props) => {
  const { children, title, type, ...rest } = props;

  let fieldTypeOption = FIELD_TYPE_OPTIONS.find(
    (option) => option.value === type
  );

  if (!fieldTypeOption && type === "list") {
    fieldTypeOption = {
      id: 11,
      label: "Table",
      value: type,
    };
  }

  return (
    <Accordion {...rest} TransitionProps={{ unmountOnExit: true }}>
      <AccordionSummary
        expandIcon={rest.expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: `1px solid ${grey["200"]}`,
        }}
      >
        <Box maxWidth={0.55} alignItems="center">
          <Tooltip title={`${title}`}>
            <Typography variant="subtitle2" noWrap>
              {title}
            </Typography>
          </Tooltip>
        </Box>
        {fieldTypeOption && (
          <Stack spacing={1} direction="row">
            <Typography variant="subtitle2" component="span">
              <Chip
                label={`${fieldTypeOption.label} Field`}
                variant="outlined"
                color="secondary"
                size="small"
              />
            </Typography>
          </Stack>
        )}
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};

export default EntaAccordion;
